import ServiceLocator from "../../global/service-locator";
import {DEFER_INIT_EVENTS} from "../../global/constants";

export default class VideoModal {
	constructor({ id, deferInit = true } = {}) {
		this.id = id;
		this.videoId = null;
		this.deferInit = deferInit;

		this.modalService = ServiceLocator.instance.modalService;

		this.$container = document.getElementById(`${id}`);
		this.$triggers = document.querySelectorAll(`[data-modal-trigger="${id}"]`);

		this.init();
	}

	init() {
		if (this.id == null) {
			throw new Error('VideoModal: id is not defined.');
		}

		if (this.$container == null) {
			throw new Error('VideoModal: container is not defined.');
		}

		if (!this.$container.id) {
			throw new Error('VideoModal: container id is not defined.');
		}

		if (!this.$triggers.length) {
			throw new Error('VideoModal: triggers are not defined.');
		}

		this.videoId = this.$container.dataset && this.$container.dataset.videoId ? this.$container.dataset.videoId : null;

		this.initVideoTriggers();
		this.bootstrap();
	}

	initVideoTriggers() {
		this.$triggers.forEach(($trigger) => {
			const $cover = $trigger.querySelector('[data-video-trigger="cover"]');

			if ($cover && $cover.tagName.toLowerCase() === 'video') {
				this.initPreview($cover);
			}
		});

	}

	initPreview($video) {
		const $parentSection = $video.closest('section.section');

		if (!$parentSection) return;

		let triggerInitialized = false;

		$video.addEventListener('loadeddata', () => {
			$video.play();
			triggerInitialized = true;
		});

		this.observer = new IntersectionObserver(entries => {
			const firstEntry = entries[0];

			if (firstEntry.isIntersecting && triggerInitialized) {
				$video.play();
			}
		}, {
			threshold: 0.5
		});
		this.observer.observe($parentSection);
	}

	bootstrap() {
		if (this.deferInit) {
			/* Run module on any user action */
			const events = DEFER_INIT_EVENTS;
			const handler = e => {
				e.stopPropagation();

				this.loadYouTubePlayer();
				this.createPlayer();

				events.forEach(event => {
					window.removeEventListener(event, handler);
				});
			};


			events.forEach(event => {
				window.addEventListener(event, handler);
			});
		} else {
			this.loadYouTubePlayer();
			this.createPlayer();
		}
	}

	loadYouTubePlayer() {
		if (document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
			return;
		}

		const firstScriptTag = document.getElementsByTagName('script')[0];
		const tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	openWithId(id) {
		if (!this.youTubePlayer) return;
		this.youTubePlayer.loadVideoById(id);
	}

	createPlayer() {
		window.youtubeApiCallbacks.push(() => {
			this.youTubePlayer = new YT.Player(this.$container.id, {
				height: '100%',
				width: '100%',
				videoId: this.videoId,
				events: {
					'onStateChange': e => {
						if (e.data === 0) {
							this.youTubePlayer.stopVideo();
						}
					}
				}
			});

			try	{
				this.modalService.register(this.id, Array.from(this.$triggers), {
					afterOpen: (trigger) => {
						if (trigger && trigger.dataset && trigger.dataset.videoId) {
							this.openWithId(trigger.dataset.videoId);
						}

						this.youTubePlayer.playVideo();
					},
					afterClose: () => {
						this.youTubePlayer.pauseVideo();
					},
					withCloseBtn: true
				});
			} catch (err) {
				console.error(`VideoModal / Modal / id: ${this.id}:`, err);
			}
		});
	}
}